import apiClient from './apiClient';

// Seller registration APIs
export const sellerAuthAPI = {
  sendOTP: (mobileNumber) =>
    apiClient.post('/seller/send-otp', { mobileNumber }),

  verifyOTP: (mobileNumber, otp) =>
    apiClient.post('/seller/verify-otp', { mobileNumber, otp }),

  verifyFirebaseToken: (mobileNumber, idToken) =>
    apiClient.post('/seller/verify-firebase-token', { mobileNumber, idToken }),

  resendOTP: (mobileNumber) =>
    apiClient.post('/seller/resend-otp', { mobileNumber }),

  createEnrolment: (enrolmentData) =>
    apiClient.post('/seller/create-enrolment', enrolmentData),

  verifyEnrolment: (enrolmentId) =>
    apiClient.get(`/seller/verify-enrolment/${enrolmentId}`),

  verifyBankDetails: (bankData) =>
    apiClient.post('/seller/verify-bank', bankData),

  completeRegistration: (registrationData) =>
    apiClient.post('/seller/register', registrationData),

  getRegistrationStatus: () =>
    apiClient.get('/seller/registration-status'),

  // NEW: GSTIN verification
  verifyGSTIN: (gstNumber, expectedTurnover) =>
    apiClient.post('/seller/verify-gstin', { gstNumber, expectedTurnover }),

  // NEW: Penny-drop bank verification
  initiatePennyDrop: (accountNumber, ifscCode, referenceId = null) =>
    apiClient.post('/seller/verify-bank-penny-drop', { accountNumber, ifscCode, referenceId }),

  confirmPennyDrop: (amount, referenceId) =>
    apiClient.post('/seller/confirm-penny-drop', { amount, referenceId }),

  requestManualReview: (reason) =>
    apiClient.post('/seller/request-manual-review', { reason }),

  // NEW: Payout status
  getPayoutStatus: () =>
    apiClient.get('/seller/payout-status'),

  // NEW: GST compliance
  flagCompliance: (expectedTurnover) =>
    apiClient.post('/seller/flag-compliance', { expectedTurnover }),
};

// Pincode lookup API
export const pincodeAPI = {
  lookup: (pincode) =>
    apiClient.get(`/pincode/${pincode}`),
};

// Seller Dashboard API (for orders, inventory, etc.)
export const sellerDashboardAPI = {
  // Orders
  getOrders: (params = {}) =>
    apiClient.get('/seller/orders', { params }),

  getOrderDetails: (orderId) =>
    apiClient.get(`/seller/orders/${orderId}`),

  updateOrderStatus: (orderId, status) =>
    apiClient.put(`/seller/orders/${orderId}/status`, { status }),

  // Returns
  getReturns: (params = {}) =>
    apiClient.get('/seller/returns', { params }),

  approveReturn: (returnId) =>
    apiClient.post(`/seller/returns/${returnId}/approve`),

  rejectReturn: (returnId, reason) =>
    apiClient.post(`/seller/returns/${returnId}/reject`, { reason }),

  // Inventory
  getInventory: (params = {}) =>
    apiClient.get('/seller/inventory', { params }),

  updateStock: (productId, quantity) =>
    apiClient.put(`/seller/inventory/${productId}`, { quantity }),

  // Payments
  getPayments: (params = {}) =>
    apiClient.get('/seller/payments', { params }),

  getPaymentSummary: () =>
    apiClient.get('/seller/payments/summary'),

  // Dashboard stats
  getDashboard: () =>
    apiClient.get('/seller/dashboard'),

  getStats: () =>
    apiClient.get('/seller/stats'),

  getProducts: (params) =>
    apiClient.get('/seller/products', { params }),
};

// Seller settings APIs
export const sellerSettingsAPI = {
  getProfile: () =>
    apiClient.get('/seller/profile'),

  updateProfile: (profileData) =>
    apiClient.put('/seller/profile', profileData),

  changePassword: (passwordData) =>
    apiClient.post('/seller/change-password', passwordData),

  updateNotifications: (notificationSettings) =>
    apiClient.put('/seller/notifications', notificationSettings),

  uploadSignature: (signatureFile) => {
    const formData = new FormData();
    formData.append('signature', signatureFile);
    return apiClient.post('/seller/upload-signature', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  },

  getTaxDetails: () =>
    apiClient.get('/seller/tax-details'),

  updateTaxDetails: (taxData) =>
    apiClient.put('/seller/tax-details', taxData),
};

// Seller address APIs
export const sellerAddressAPI = {
  getAddresses: () =>
    apiClient.get('/seller/addresses'),

  createAddress: (addressData) =>
    apiClient.post('/seller/addresses', addressData),

  updateAddress: (addressId, addressData) =>
    apiClient.put(`/seller/addresses/${addressId}`, addressData),

  deleteAddress: (addressId) =>
    apiClient.delete(`/seller/addresses/${addressId}`),
};

// Utility function to handle API errors
export const handleAPIError = (error) => {
  if (error.response) {
    return {
      status: error.response.status,
      message: error.response.data?.message || 'An error occurred',
      errors: error.response.data?.errors || {},
    };
  } else if (error.request) {
    return {
      status: 0,
      message: 'No response from server. Please check your internet connection.',
      errors: {},
    };
  } else {
    return {
      status: 0,
      message: error.message || 'An unexpected error occurred',
      errors: {},
    };
  }
};
